import { Route, Routes } from 'react-router-dom';
import { Header } from '@/components/header';
import { VersionFooter } from '@/components/version-footer';
import { Submit } from '@/pages/Submit';
import { Learn } from '@/pages/Learn';
import { About } from '@/pages/About';
import { Mcp } from '@/pages/Mcp';
import { Terms } from '@/pages/Terms';
import { Admin } from '@/pages/Admin';

export default function App() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Submit />} />
          <Route path="/learn" element={<Learn />} />
          <Route path="/about" element={<About />} />
          <Route path="/mcp" element={<Mcp />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
      <VersionFooter />
    </div>
  );
}
